import { render, staticRenderFns } from "./myQrcode.vue?vue&type=template&id=55d8eafc&scoped=true&"
import script from "./myQrcode.vue?vue&type=script&lang=js&"
export * from "./myQrcode.vue?vue&type=script&lang=js&"
import style0 from "./myQrcode.vue?vue&type=style&index=0&id=55d8eafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8eafc",
  null
  
)

export default component.exports